import React, {useContext} from "react";
import ForecastDetailView from "../ForecastDetailView/ForecastDetailView";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import VendorContext from "../../../contexts/VendorContext";
import {SocketContext} from "../../../contexts/SocketContext";
import UiContext from "../../../contexts/UiContext";
import {useLocation, useMatch, useNavigate} from "react-router-dom";

type Props = {};

export const ForecastDetailWrapper = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const vendorModel = useContext(VendorContext);
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const navigate = useNavigate();
    const location = useLocation();
    const match = useMatch("/forecast/:guid")

    return <ForecastDetailView
        socket={socket}
        userModel={userModel}
        supplierModel={supplierModel}
        vendorModel={vendorModel}
        notifyFn={uiContext.notifyFn}
        match={match}
        history={navigate}
        location={location}
        setActivityIndicator={uiContext.setActivityIndicator}
    />;
};
